import _ from '@/utils/lodash-optimized'
import { Component } from 'react'
import { connect } from 'react-redux'

import { withDiscardDialog } from '../../lib/global-discard-dialog'
import { phoneToFhir } from '../../lib/Proxy/lib/phone'
import { Warning } from '../igao/components/warnings/warning'
import { PlainButton } from '../shared/Button'
import { bindTargetMixin } from '../shared/FormBuilder'
import { CircularProgress } from '../shared/NarusMaterial'

import actions from './actions'
import { AuthorizationMethodSettings } from './AuthorizationMethodSettings'
import { renderPersonalInformation, renderNotifications, renderPreference } from './shared'

const prepareValue = profile => {
    if (!profile) {
        return {}
    }

    return {
        ...profile,
        phone: _.chain(profile).get('phone', '').split('+1').last()
            .value(),
        contact: _.chain(profile).get('contact', '').split('+1').last()
            .value(),
        on_patient_folder_open: profile.on_patient_folder_open ?? 'null',
        on_encounter_open: profile.on_encounter_open ?? 'null'
    }
}

const prepareProfile = value =>
  value && {
    ...value,
    phone: value.phone && `+1${phoneToFhir(value.phone)}`,
    contact: value.contact && `+1${phoneToFhir(value.contact)}`,
    onduty: value.onduty ?? false,
    monitoring: value.monitoring ?? false,
    oncall: value.oncall ?? false,
    concierge: value.concierge ?? false,
    practitioner_notifications: value.practitioner_notifications ?? false,
    on_patient_folder_open: value.on_patient_folder_open === 'null' ? null : value.on_patient_folder_open ?? null,
    on_encounter_open: value.on_encounter_open === 'null' ? null : value.on_encounter_open ?? null
  }

@withDiscardDialog
class ProfileForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)

      // Don't override state here - bindTargetMixin already set it
      // Just bind methods
    this.onSave = this.onSave.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.value, this.props.value)) {
            this.setState({
                value: this.props.value || {},
                initialValues: this.props.value || {}
            })
        }
    }

  get canSave () {
    return (
        !_.isEqual(this.state.value, this.state.initialValues) &&
      this.isValid()
    )
  }

  get canCancel () {
      return !_.isEqual(this.state.value, this.state.initialValues)
  }

  onCancel () {
    this.props.discardDialog.show(this.props.formKey, this.props.onCancel)
  }

  onSave () {
    this.props.onSave(this.state.value)
    this.props.discardDialog.resetForm(this.props.formKey)
  }

  render () {
    return (
      <form style={{ padding: '0 10px' }}>
        <h2
          className='setting-header'
        >
          Personal Info
        </h2>
          {renderPersonalInformation.call(this, true)}
        <h2
          className='setting-header'
          style={{ marginTop: '40px' }}
        >
          Notifications
        </h2>
          {renderNotifications.call(this, this.props.role)}

        <h2
          className='setting-header'
          style={{ marginTop: '40px' }}
        >
          Preferences
        </h2>
          {renderPreference.call(this)}

        <div
          className='row margin-top'
          style={{ marginTop: '35px', marginBottom: '40px' }}
        >
          {this.canCancel && (
            <div className='col-xs-12' style={{ marginBottom: '15px' }}>
                <Warning
                  type='concurrent'
                  title='You will need to log out and log in again to apply changes'
                  infoStyle={{ paddingBottom: '2px' }}
                />
            </div>
          )}
          <div className='col-xs-12'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <PlainButton
                disabled={!this.canCancel}
                style={{ margin: '0 6px' }}
                label='Cancel'
                btnType='contained'
                onClick={this.onCancel}
              />
              <PlainButton
                disabled={!this.canSave}
                color='primary'
                type='contained'
                label='Save'
                onClick={this.onSave}
              />
            </div>
          </div>
        </div>

          {this.props.showPasskeySettings && (
              <>
                  <h2
              className="setting-header"
              style={{ marginTop: '40px' }}
                  >
                      Passkey Settings
                  </h2>
                  <p style={{ color: '#666', fontSize: '14px', paddingInline: '16px', marginBottom: '20px' }}>
                      Manage registered passkey devices used for passwordless sign-in.
                  </p>
                  <AuthorizationMethodSettings userId={this.props.userId}/>
              </>
          )}

        <div style={{ marginBottom: '70px' }} />
      </form>
    )
  }
}

function mapStateToProps (state) {
  return {
    profile: state?.profile ?? {},
      role: state?.auth?.profile?.app_metadata?.roles?.meta?.role,
      userId: state?.auth?.profile?.sub
  }
}

@connect(mapStateToProps)
export default class Profile extends Component {
  UNSAFE_componentWillMount () {
    const { dispatch } = this.props
    dispatch(actions.get())
  }

  render () {
    const { profile, dispatch, role, userId } = this.props
      const authorizationFlow = profile?.profile?.authorization_flow
      const showPasskeySettings = authorizationFlow === 'no_mfa'

      return (
      <div
        className='wrapper'
        style={{ marginTop: '40px' }}
      >
        <div className='assessment'>
          <div className='assessment-body'>
            {profile.loading
              ? (
                <CircularProgress />
              )
              : (
                <ProfileForm
                  formKey='profile'
                  value={prepareValue(profile.profile)}
                  onSave={value => {
                    dispatch(actions.set(prepareProfile(value)))
                  }}
                  onCancel={() => {
                    dispatch(actions.get())
                  }}
                  role={role}
                  userId={userId}
                  showPasskeySettings={showPasskeySettings}
                />
              )}
          </div>
        </div>
      </div>
    )
  }
}
